import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-bottom: ${({ theme }) => theme.CONSTANTS.XH * 5}px;
  z-index: 15;
`;
